import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa7e8e1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "under-line-input" }
const _hoisted_2 = ["size", "contenteditable"]

import { computed, nextTick, onMounted, PropType, ref, watch } from "vue";
import { ElSelect, ElOption } from "element-plus";
import { getBytesLength } from "@/utils/common";
import { unLock } from "@/utils/liner-lock";


export default /*#__PURE__*/_defineComponent({
  props: {
  inputValue: {
    type: String,
  },
  correct_answer: {
    type: String,
  },
  options: {
    type: Array,
  },
  disabled: {
    type: Boolean,
  },
  type: {
    type: String as PropType<"input" | "select">,
    default: "input",
  },
  style: {
    type: Object,
  },
},
  emits: ["update:inputValue"],
  setup(__props, { emit: emits }) {

const props = __props



const mixInputSize = 8;
const inputSize = ref(mixInputSize);



const content = ref(
  props.inputValue || "" // "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;&nbsp;;&nbsp;"
);

watch(
  () => content.value,
  (newVal) => {
    const nowSize = getBytesLength(newVal);
    inputSize.value = nowSize > mixInputSize ? nowSize : mixInputSize;
    emits("update:inputValue", newVal);
    if (newVal.length === 0 && inputContentRef?.value) {
      inputContentRef!.value!.value = "";
    }
  },
  { immediate: true }
);

const isFillType = computed(() => {
  return !props.options;
});

//* 下划线的填空

const inputContentRef = ref<HTMLElement>();

const onInputContentBlur = () => {
  content.value = inputContentRef.value?.value
    .replaceAll("&nbsp;", "")
    .trim() as string;
};

const onInputContentInput = () => {
  content.value = inputContentRef.value?.value
    .replaceAll("&nbsp;", "")
    .trim() as string;
};

// * 弹窗的填空

const selectOptions = computed(() => {
  return ((props.options || []) as string[]).map((option: string) => {
    return { label: option, value: option };
  });
});
const contentWidth = computed(() => {
  if (content.value) {
    return getTextWidth(
      content.value,
      {
        fontSize: "38px",
        lineHeight: " 60px",
      },
      30
    );
  }
  return `120px`;
});

const getTextWidth = (str = "", style = {}, offset = 0) => {
  const dom = document.createElement("span");
  Object.entries(style).forEach(([key, value]) => {
    (dom.style as any)[key] = value;
  });
  dom.textContent = str;
  document.body.appendChild(dom);
  const width = dom.offsetWidth;
  document.body.removeChild(dom);
  return `${width + offset}px`;
};

//* 在disable中 标明答案的正确与否
const isCorrect = computed(() => {
  return true;
  // if (!props.disabled) {
  //   return true;
  // }
  // return props.inputValue === props.correct_answer;
});

onMounted(async () => {
  await nextTick();
  if (isFillType.value) {
    inputContentRef.value?.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key == "Enter") {
        e.preventDefault();
        return false;
      }
      return true;
    });
    inputContentRef!.value!.value = `${content.value}`;
  }
  unLock();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isFillType))
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          size: inputSize.value,
          maxlength: "20",
          class: _normalizeClass(["under-line-input-content", _unref(isCorrect) ? 'correct_answer' : 'error_answer']),
          contenteditable: !props.disabled,
          ref_key: "inputContentRef",
          ref: inputContentRef,
          onBlur: onInputContentBlur,
          onInput: onInputContentInput,
          style: _normalizeStyle(props.style)
        }, null, 46, _hoisted_2))
      : (_openBlock(), _createBlock(_unref(ElSelect), {
          key: 1,
          modelValue: content.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
          placeholder: " ",
          disabled: props.disabled,
          class: _normalizeClass(_unref(isCorrect) ? 'correct_answer' : 'error_answer'),
          "popper-class": "under-line-input-content_select_popper",
          style: _normalizeStyle({ width: _unref(contentWidth) })
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions), (option) => {
              return (_openBlock(), _createBlock(_unref(ElOption), {
                key: option.value,
                value: option.value,
                label: option.label
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "class", "style"]))
  ]))
}
}

})